<template>
  <v-tooltip right>
    <template v-slot:activator="{on, attrs}">
      <v-icon
        v-if="msg"
        color="third"
        v-bind="attrs"
        v-on="on"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    <span>{{ msg }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'MoreInfoToolTip',
  props: {
    msg: { required: false, type: String },
  },

  data() {
    return {};
  },

  methods: {},
};
</script>
